import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { isDev, locale } from "../helpers/globals";

const resources = {
  en_us: { translation: require("./en.json") },
  en_gb: { translation: require("./en.json") },
  en_au: { translation: require("./en.json") },
  en_nz: { translation: require("./en.json") },
  de_at: { translation: require("./de.json") },
  de_de: { translation: require("./de.json") },
  de_ch: { translation: require("./de.json") },
  fr_fr: { translation: require("./fr_fr.json") },
  fr_ca: { translation: require("./fr_ca.json") },
};

i18n.use(initReactI18next).init({
  resources,
  lng: locale,
  fallbackLng: "en_us",
  debug: isDev,
  interpolation: {
    escapeValue: false, // not needed for react
    format: (value, format) => {
      if (format === "bold") return `**${value}**`;

      return value;
    },
  },
});

export default i18n;
